<template>
	<div style="width: 1200px;margin: 0 auto;">

		<!-- banner资讯+文件公告 -->
		<div style="margin: 30px 0 20px 0;display: flex;">
			<newsCard></newsCard>
			<div class="zjxWarpList">
				<div class="sinfo_list_head">
					<div class="big_title_box">

						<div :class="[changeIndex == index ?'title_p__active':'title_p__normal','big_title_p']"
							v-for="(item,index) in nav_list" @click="ClickNav(item.key,index)" :key="index">

							<p>{{item.label}}</p>
						</div>

					</div>
					<span class="sinfo_list_head_span" @click="$router.push('/dynamic/list')">更多></span>
				</div>
				<infoList orgin="announce" :column_code="columnCode1" :page_size="8"></infoList>
			</div>
		</div>
		<!-- 课程banner -->
		<courseBanner></courseBanner>
		<!-- 精品课程 -->
		<div class="">
			<div class="normalFlex courseFlex">
				<div class="normalFlex">
					<span class="zjx_course_span"></span>
					<p class="zjx_course_p">公益课程</p>
				</div>
				<div>
					<div class=""></div>
				</div>
				<!-- <p class="courseFlex_right">更多></p> -->
			</div>
			<div class="web_course_list">
				<div v-for="(item,index) in classes" class="web_course_li" :key="index"
					@click="goDetail(item.id,item.name)">
					<div style="width: 280px;height: 156px;overflow: hidden;">
						<img class="web_course_img" :src="item.img ? item.img : path" alt="">
					</div>
					<div style="height: 100px;background-color: #fff;">
						<p class="best_courses_p">{{item.name}}</p>
						<span class="web_course_pView">
							<p class="best_courses_p__p1"> {{item.class_type_name}}</p>
							<p class="best_courses_p__p2">￥{{item.price}}</p>
						</span>
					</div>
				</div>
			</div>
		</div>
		<!-- 自定义名称 -->
		<div class="">
			<div class="normalFlex courseFlex" v-if="actionList.length">
				<div class="normalFlex">
					<span class="zjx_course_span"></span>
					<p class="zjx_course_p">工作平台</p>
				</div>
				<div>
					<div class="">

					</div>
				</div>
				<!-- <p class="courseFlex_right">更多></p> -->
			</div>
			<div class="web_course_list">
				<div v-for="(item,index) in actionList" class="web_course_li" :key="index" @click="Click(item.link)">
					<div style="width: 280px;height: 156px;overflow: hidden;">
						<img class="web_course_img" :src="item.picture" alt="">
					</div>
					<div style="height: 60px;background-color: #fff;">
						<span class="web_course_pView">
							<p class="web_course_pView__p">{{item.name}}</p>
						</span>
					</div>
				</div>
			</div>
		</div>
		<!-- 快速链接 -->
		<div class="">
			<div class="normalFlex courseFlex">
				<div class="normalFlex">
					<span class="zjx_course_span"></span>
					<p class="zjx_course_p">快速链接</p>
				</div>
				<div>
					<div class="">
					</div>
				</div>
				<!-- <p class="courseFlex_right">更多></p> -->
			</div>
			<div class="view_father3">
				<div class="course_box" v-for="(item,index) in soures_list" :key="index" @click="Click(item.link)">
					<p v-html="item.name"></p>
					<img :src="item.logo" alt="">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import newsCard from './components/newsCard.vue'
	import infoList from './components/infoList.vue'
	import courseBanner from './components/courseBanner.vue'
	// import zjxCard from './components/zjxCard.vue'

	import {
		getClaes
	} from "../../api/moudles/user";
	import {
		getWebNav,
		getWebWorkArea
	} from "../../api/moudles/home";


	export default {
		components: {
			newsCard,
			infoList,
			// zjxCard,
			courseBanner
		},
		data() {
			return {
				changeIndex: 0,
				path: require('@/assets/img/course.png'),
				changeLabList: [{
					label: '通知公告'
				}, {
					label: '行业动态'
				}, {
					label: '政策资讯'
				}],
				columnCode1: '',
				columnCode2: '',
				classes: [],
				cate: '',
				bgcOne: 'linear-gradient(90deg, #FA7B81 0%, #FFA281 100%)',
				bgcTwo: 'linear-gradient(90deg, #E19D47 0%, #DB8A1C 100%)',
				// 精品工程展示
				// 入会等
				actionList: [],
				// 精品课程资讯
				soures_list: [],
				nav_list: []
			}
		},
		created() {
			setTimeout(() => {
				//this.columnCode1 = "CE631BED-54AD-8A64-67E6-659B700BC5BF"
				this.columnCode2 = "B9D77DE2-5615-3BF5-77C3-AB1B07F10E54"
			})

			this.getClaList()
			this.getWebWorkArea()
		},
		methods: {
			goDetail(id, name) {

				this.$router.push({
					path: '/classdetail',
					query: {
						id: id,
						name: name
					}
				})
			},

			ClickNav(key, index) {

				this.changeIndex = index

				this.columnCode1 = key
			},
			Click(link) {
				if (link) {
					window.open(link)

				}
			},

			getClaList() {
				getClaes({

					data: {

						tag: '',
						cate: this.cate,

						recommend: 1

					},

					success: (res) => {

						// console.log(res)
						//const newList = res.data
						this.classes = res.data
						//this.classes.push(...newList)
					}

				})
			},
			getWebWorkArea() {
				getWebWorkArea({
					data: {
						column_code: 'DBD644E1-B9D1-63C1-F33E-9006F4705A5F',
					},
					success: (res) => {
						// console.log('快速链接：',res)
						this.soures_list = res.data
					}
				})

				getWebWorkArea({
					data: {
						column_code: '9908861D-BC71-1917-CD4B-BE44D3BFE383',
					},
					success: (res) => {
						// console.log('工作平台',res)
						this.actionList = res.data

					}

				})

				getWebNav({
					data: {
						column_code: '',
						position: 2,
					},
					success: (res) => {

						// console.log(963963963)
						// console.log(res)
						// console.log(56765765757)

						this.nav_list = res.data

						if (this.nav_list.length > 0) {
							this.columnCode1 = this.nav_list[0].key
						}


					}

				})

			},

			// 入会须知等跳转
			fourNavTo(item, index) {
				if (index == 0) {
					this.$router.push('/admissionNotice')
				} else if (index == 1) {
					this.$router.push('/register')
				} else if (index == 2) {
					this.$router.push('/login')
				} else {
					this.$message('开发中...');
					// this.$router.push('/vipcheck')
				}
			},
		}
	}
</script>

<style scoped>
	.title_p__active {
		font-family: PingFangSC-Semibold;
		color: #F4F9FF;
		font-weight: 600;
		background: #0182FD;
		transform: skewX(-15deg);
	}

	.title_p__active p {
		transform: skewX(15deg);
	}

	.title_p__normal {
		font-family: PingFangSC-Medium;
		color: #000000;
		font-weight: 500;
	}

	.big_title_p {
		font-size: 16px;
		letter-spacing: 0;
		line-height: 40px;
		min-width: 80px;
		margin-right: 30px;
		height: 40px;
		text-align: center;
		cursor: pointer;
	}

	.sinfo_list_head {
		display: flex;
		justify-content: space-between;
		height: 41px;
		align-items: center;
		border-bottom: 1px solid #93A8E2;
		margin-left: 40px;
	}

	.big_title_box {
		display: flex;
	}

	.web_course_list {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		grid-column-gap: 20px;
	}

	.web_course_li {
		width: 280px;
		border-radius: 8px;
		overflow: hidden;
		box-shadow: 0px 4px 10px 4px rgb(0 0 0 / 6%);
		margin-bottom: 27px;
	}

	.web_course_img {
		width: 280px;
		height: 156px;
		transition: all .3s;
	}

	.web_course_img:hover {
		transform: scale(1.1);
		cursor: pointer;
	}

	.web_course_pView {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 8px 18px 11px;
	}

	.web_course_pView__p {
		font-family: PingFangSC-Medium;
		font-size: 18px;
		color: #000000;
		letter-spacing: 0;
		text-align: left;
		font-weight: 500;
		line-height: 42px;
	}

	.normalFlex {
		display: flex;
		align-items: center;
	}

	.courseFlex {
		height: 50px;
		justify-content: space-between;
		padding-right: 12px;
		margin-bottom: 30px;
	}

	.view_father3 {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		grid-column-gap: 20px;
		margin: 30px 0;
	}

	.courseFlex_right {
		font-family: PingFangSC-Regular;
		font-size: 14px;
		color: #D40D16;
		letter-spacing: 0;
		text-align: center;
		line-height: 18px;
		font-weight: 400;
	}

	.courseFlex_right:hover {
		cursor: pointer;
		text-decoration: underline;
	}

	/* 精品课程 */
	.best_courses_p {
		font-family: PingFangSC-Regular;
		font-size: 16px;
		color: #000000;
		letter-spacing: 0;
		text-align: left;
		line-height: 26px;
		font-weight: 400;
		padding: 7px 18px 0px;
		
		word-break: break-all;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}

	.best_courses_p__p1 {
		font-family: PingFangSC-Regular;
		font-size: 14px;
		color: #999999;
		letter-spacing: 0;
		text-align: left;
		font-weight: 400;
	}

	.best_courses_p__p2 {
		font-family: AlibabaPuHuiTi-Bold;
		font-size: 18px;
		color: #E02020;
		letter-spacing: 0;
		text-align: right;
		font-weight: 700;
	}

	.course_box {
		box-sizing: border-box;
		padding: 0 20px;
		cursor: pointer;
		width: 280px;
		height: 80px;
		background-image: linear-gradient(to right, #f2f8fe 100%, #ffffff 100%);
		border-radius: 1.33px;
		display: flex;
		align-items: center;
		justify-content: space-around;
		margin-bottom: 20px;
		border: 1px solid rgba(242, 244, 246, 1);
	}

	.course_box img {
		width: 44px;
		height: 44px;
	}

	.course_box p {
		padding-right: 20px;
		font-size: 18px;
		letter-spacing: 0;
		text-align: center;
		font-weight: 600;
		font-family: PingFangSC-Medium;
		color: rgba(0, 0, 0, 0.85);
	}

	.zjxheader {
		height: 100px;
		width: 100%;
		background-color: #c01219;
	}

	.zjxheader_center {
		width: 1200px;
		margin: 0 auto;
		height: 100px;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.zjxheader_center__left {}

	.zjxheader_center__left_p {
		height: 50px;
		line-height: 50px;
		text-align: right;
		color: #fff;

		font-family: PingFangSC-Regular;
		font-size: 14px;
		letter-spacing: 0;
		font-weight: 400;
	}

	.zjxWarpList {
		width: 600px;
		height: 380px;
	}

	.zjxRightView {
		width: 590px;
		display: flex;
		justify-content: space-between;
	}

	.zjxRightView_left {
		background-color: #fff;
		width: 394px;
	}

	.zjxRightView_Right {
		width: 186px;
		display: flex;
		flex-flow: column;
		justify-content: space-between;
	}

	.zjxRightView_Right__view {
		height: 80px;
		width: 186px;
		color: #fff;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}

	.zjxRightView_Right__view p {
		margin-left: 14px;
	}

	.zjxRightView_Right__view:nth-child(odd) {
		background-color: #d40d16;
	}

	.zjxRightView_Right__view:nth-child(even) {
		background-color: #C19B61;
	}

	.zjx_course_span {
		display: inline-block;
		width: 5px;
		height: 24px;
		background: #0182FD;
	}

	.zjx_course_p {
		margin-left: 15px;
		font-size: 24px;
		letter-spacing: 0;
		font-weight: 600;
		font-family: PangMenZhengDao;
		color: #131415;
	}

	.grestProgrma {
		display: flex;
		justify-content: space-between;
	}

	.grestProgrma_view {
		display: flex;
		flex-flow: column;
		align-items: center;
		border: 1px solid rgba(219, 219, 219, 1);
		cursor: pointer;
		position: relative;
	}

	.grestProgrma_view img {
		width: 294px;
		height: 246px;
	}

	.grestProgrma_view p {
		display: inline-block;
		margin: 10px 0;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: 270px;
	}
</style>